import React from "react";
import BAGroupTimeFormat from "../../../../utils/formatters/BAGroupTimeFormat";
import BdrModal from "../../../../components/BdrModal/BdrModal";
import BdrButton from "../../../../components/BdrButton/BdrButton";

// True when a GraphQL error carries the server's NEEDS_PERIOD_CONFIRM sentinel.
// Checks graphQLErrors[].message (the robust source) AND err.message (Apollo
// surfaces the first error there too) so detection doesn't depend on wrapping.
export function isNeedsPeriodConfirm(err) {
  const msgs = [
    err?.message,
    ...((err?.graphQLErrors || []).map((e) => e?.message)),
  ].filter(Boolean);
  return msgs.some((m) => String(m).includes("NEEDS_PERIOD_CONFIRM"));
}

// Shared confirmation shown when a move would shift an APPROVED job's labor pay
// across a pay-period boundary touching an already-settled (past) week. Reused
// by every move surface (EditEventModal date-edit + promote, CreateEventModal
// re-submit, the invoice-date editor). The server owns the decision (it threw
// NEEDS_PERIOD_CONFIRM); this just surfaces the dates the host already has.
const PayPeriodMoveConfirmModal = ({ open, oldMs, newMs, busy, onCancel, onConfirm }) => {
  const fmt = (ms) => (ms ? BAGroupTimeFormat(ms, true, true) : "—");

  return (
    <BdrModal
      open={!!open}
      onClose={busy ? () => {} : onCancel}
      closeOnBackdrop={!busy}
      closeOnEsc={!busy}
      title="Move across pay periods?"
      variant="panel"
      size="md"
      /* peak: every surface that can host this already has a modal open
         (EditEventModal, the promote confirm, the quote overlay, the invoice
         editor), so this sits on the highest rung. */
      layer="peak"
      actions={
        <>
          <BdrButton disabled={busy} onClick={onCancel}>
            Cancel
          </BdrButton>
          <BdrButton
            variant="danger"
            confirm={false}
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? "Moving..." : "Move anyway"}
          </BdrButton>
        </>
      }
    >
      <p className="bdr-confirm-note">
        {oldMs ? (
          <>
            This job is <b>approved</b> and you're moving it from the week of{" "}
            <b>{fmt(oldMs)}</b> to the week of <b>{fmt(newMs)}</b> — a different
            pay period, and at least one of those weeks has already closed.
          </>
        ) : (
          <>
            This <b>approved</b> job is moving to the week of{" "}
            <b>{fmt(newMs)}</b> — a different, already-closed pay period.
          </>
        )}{" "}
        This can change an already-issued paycheck. Continue?
      </p>
    </BdrModal>
  );
};

export default PayPeriodMoveConfirmModal;
